import DashboardIcon from "./mainmenu/icon-mainmenu-dashboard.svg";
import MapOverviewIcon from "./mainmenu/icon-mainmenu-maps.svg";
import ReportsIcon from "./mainmenu/icon-mainmenu-reports.svg";
import ManageRolesIcon from "./mainmenu/icon-mainmenu-roles.svg";
import ManageRuleIcon from "./mainmenu/icon-mainmenu-rules.svg";
import VehicleAlertIcon from "./mainmenu/icon-mainmenu-asset-alert.svg";
import BuzzerAlertIcon from "./mainmenu/icon-mainmenu-buzzer-alert.svg";
import CameraAdminIcon from "./mainmenu/icon-mainmenu-camera.svg";
import CrashTrackIcon from "./mainmenu/icon-mainmenu-crashtrack.svg";
import IncidentReviewIcon from "./mainmenu/icon-mainmenu-incident.svg";

import MenuIconUser from "./adminmenu/menuicon-user.svg";
import MenuIconUsers from "./adminmenu/menuicon-users.svg";
import MenuIconVehicle from "./adminmenu/menuicon-vehicle.svg";
import GroupAdminIcon from "./group-admin-icon.svg";
import MenuIconTruck from "./adminmenu/menuicon-truck.svg";
import MenuIconGeozone from "./adminmenu/menuicon-geozone.svg";
import MaintenanceAdminIcon from "./maintainance-admin-icon.svg";
import MenuIconDocuments from "./adminmenu/menuicon-documents.svg";
import MenuIconImportExport from "./adminmenu/menuicon-importExport.svg";
import MenuIconHeatmap from "./adminmenu/menuicon-heatmap.svg";
import MenuIconWhiteLabel from "./adminmenu/menuicon-whitelabel.svg";
import ComplianceIcon from "./compliance-icon.svg";
import MenuIconIncidentReview from "./adminmenu/menuicon-incidentReview.svg";
import MenuIconInCabCoaching from "./adminmenu/menuicon-incab.svg";

export default {
  dashboard: DashboardIcon,
  map_overview: MapOverviewIcon,
  reports: ReportsIcon,
  manage_roles: ManageRolesIcon,
  // manage_rule_alert: ManageRuleIcon,
  vehicle_alert: VehicleAlertIcon,
  buzzer_alert: BuzzerAlertIcon,
  camera_admin: CameraAdminIcon,
  crash_track: CrashTrackIcon,
  compliance_admin: ComplianceIcon,

  // items removed from main menu
  maintenance_admin: MaintenanceAdminIcon,
  incident_review: IncidentReviewIcon,
  // group_admin: GroupAdminIcon,
  // administrators: GroupAdminIcon,

  admins: {
    user: MenuIconUser,
    users: MenuIconUsers,
    rules: ManageRuleIcon,
    vehicle: MenuIconVehicle,
    groups: GroupAdminIcon,
    truck: MenuIconTruck,
    geozone: MenuIconGeozone,
    maintenance: MaintenanceAdminIcon,
    documents: MenuIconDocuments,
    importExport: MenuIconImportExport,
    heatmap: MenuIconHeatmap,
    whitelabel: MenuIconWhiteLabel,
    incidentReview: MenuIconIncidentReview,
    incabcoaching: MenuIconInCabCoaching,
  },
};
